document.addEventListener('DOMContentLoaded', function() {
  // --- Utility: Update URL params without reloading ---
  function updateUrlParams(params) {
    console.log('Updating URL params from component-product-url-sync.js 39', params);
    const url = new URL(window.location);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null) {
        url.searchParams.set(key, encodeURIComponent(value).replace(/%20/g, '+'));
      } else {
        url.searchParams.delete(key);
      }
    });
    console.log('URL from component-product-url-sync.js 42', url);
    window.history.replaceState({}, '', url);
  }

  function isVisible(el) {
    if (!el) return false;

    while (el) {
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      el = el.parentElement;
    }
    return true;
  
  }

  // --- Get current selections from the form ---
  function getCurrentSelections() {
    console.log('Getting current selections from component-product-url-sync.js 38');
    const values = {
      subscription: false,
      servings: null,
      payment_type: null,
    };
  
    // Subscription
    const purchaseRadios = document.querySelectorAll('input[name^="type_of_subscription_"]');
    if (purchaseRadios.length === 1 && isVisible(purchaseRadios[0])) {
      // If only one option, use its value
      values.subscription = purchaseRadios[0].value === 'subscription' ? 'true' : 'false';
    } else {
      // Otherwise use checked radio value
      const purchaseRadio = document.querySelector('input[name^="type_of_subscription_"]:checked');
      if (purchaseRadio && isVisible(purchaseRadio)) {
        values.subscription = purchaseRadio.value === 'subscription' ? 'true' : 'false';
      }
    }
  
    // Servings
    const shipmentSelect = document.querySelector('.product-variant-shipment-amount');
    //if (isVisible(shipmentSelect)) {
      const selectedOption = shipmentSelect.options[shipmentSelect.selectedIndex];
      const shipmentAttributeValue = selectedOption?.getAttribute('data-shipment-attribute-value');
      if (shipmentAttributeValue) {
        values.servings = shipmentAttributeValue;
      } else {
        values.servings = selectedOption.value;
      }
    //}
  
    // Payment Type
    const paymentTypeSelect = document.querySelector('.product-payment-type--select');
    if (isVisible(paymentTypeSelect)) {
      const checkedRadio = paymentTypeSelect.querySelector('input[type="radio"].product-payment-type-radio:checked');
      if (checkedRadio) {
        console.log('Checked radio from component-product-url-sync.js 74', checkedRadio);
        const paymentType = checkedRadio.getAttribute('data-payment-type');
        console.log('Payment type from component-product-url-sync.js 76', paymentType);
        if (paymentType) values.payment_type = paymentType;
      }
    }else{
      console.log('Payment type container not visible from component-product-url-sync.js 78');
    }
    
    return values;
  }
  

  // --- Set form selections from URL params --- 
  function setSelectionsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const paramHandlers = {
      subscription: () => {
        const value = params.get('subscription') === 'true' ? 'subscription' : 'one-time';
        const radio = document.querySelector(`input[name^="type_of_subscription_"][value="${value}"]`);
        if (radio){
          radio.checked = true;
          const changeEvent = new Event('change', {bubbles: true});
          radio.dispatchEvent(changeEvent);
        } 
      },
      servings: () => {
        const select = document.querySelector('.product-variant-shipment-amount');
        const servingsRaw = params.get("servings");
        const servings = servingsRaw.replace(/\+/g, ' ');
        if (select && servings) {
          const matchingOption = Array.from(select.options).find(opt => {
            const attrValue = opt.getAttribute('data-shipment-attribute-value');
            return attrValue
              ? attrValue.includes(servings)
              : opt.value.includes(servings);
          });
          if (matchingOption) {
            // added delay to ensure the event is triggered after variant picker has initialized and default variant is set
            setTimeout(() => {
              select.value = matchingOption.value;
              select.dispatchEvent(new Event('change', { bubbles: true, detail: { serving: true } }));
            }, 200);
          } else if (params.get('subscription') != 'true') {
            // reset serving to default one-time purchase variant
            document.dispatchEvent(new CustomEvent('variant-picker:check-subscription', { bubbles: true }));
          }
        }
      },
      payment_type: () => {
        const select = document.querySelector('.product-payment-type--select');
        const paymentType = params.get('payment_type');
        if (select && paymentType) {
          const radio = select.querySelector(`input[type="radio"].product-payment-type-radio[data-payment-type="${paymentType}"]`);
          console.log('Radio from component-product-url-sync.js 128', radio);
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    };

    Object.keys(paramHandlers).forEach(param => {
      if (params.has(param)) paramHandlers[param]();
    });
  }

  // --- Listen for changes on all relevant inputs ---
  function addListeners() {
    const selectors = {
      'input[name^="type_of_subscription_"]': true,
      '.product-variant-shipment-amount': false,
      '.product-payment-type--select': false,
    };

    for (const [selector, multiple] of Object.entries(selectors)) {
      const elements = multiple ? 
        document.querySelectorAll(selector) : 
        [document.querySelector(selector)].filter(Boolean);

      elements.forEach(el => {
        // Special handling for payment type radio buttons
        if (selector === '.product-payment-type--select') {
          const radioButtons = el.querySelectorAll('input[type="radio"].product-payment-type-radio');
          console.log('Radio buttons from component-product-url-sync.js 159', radioButtons);
          radioButtons.forEach(radio => {
            console.log('Radio from component-product-url-sync.js 161', radio);
            radio.addEventListener('change', () => updateUrlParams(getCurrentSelections()));
          });
        } else {
          console.log('Element from component-product-url-sync.js 169', el);
          el.addEventListener('change', () => {
            console.log('Element change event from component-product-url-sync.js 171');
            updateUrlParams(getCurrentSelections());
          });
        }
      });
    }
  }

  // Initial URL update: wait for variant-picker "all radios ready" or fallback after delay
  const URL_SYNC_READY_FALLBACK_MS = 600;
  let initialUrlSyncDone = false;

  function runInitialUrlUpdate() {
    if (initialUrlSyncDone) return;
    initialUrlSyncDone = true;
    updateUrlParams(getCurrentSelections());
  }

  const fallbackTimeout = setTimeout(runInitialUrlUpdate, URL_SYNC_READY_FALLBACK_MS);
  document.addEventListener('variant-picker:url-sync-ready', () => {
    clearTimeout(fallbackTimeout);
    runInitialUrlUpdate();
  }, { once: true });

  setSelectionsFromUrl();
  addListeners();
});